import { Box, Stack } from '@mui/material';
import React from 'react';

import BlackDot from '../WsIcon/BlackDot';
import { WsTypography } from '../WsTypography';
import { WsTypoColors, WsTypoVariants } from '../WsTypography/WsTypography';
export interface WsListProps {
  title?: string;
  listArray?: string[];
}

const WsList = ({ title, listArray = [] }: WsListProps) => (
  <Box>
    {title && (
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
        {title}
      </WsTypography>
    )}
    <Box p={1}>
      {listArray.map((item) => (
        <Stack direction="row" spacing={2} key={item}>
          <Box pt={0.5}>
            <BlackDot />
          </Box>
          <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.BLACK}>
            {item}
          </WsTypography>
        </Stack>
      ))}
    </Box>
  </Box>
);
export default WsList;
